import { useState, useCallback, useEffect } from 'react';
import ProformaInvoiceModel from '../../../core/api/invoice/ProformaInvoiceModel';
import { EmailState } from '../types';

/**
 * Hook for managing the last proforma invoice date
 * @param clientId The client ID to fetch the last proforma date for
 * @param email Current email state that may affect the proforma date
 * @returns The last sent proforma date as a string
 */
export const useLastProformaDate = (clientId: string, email: EmailState | null) => {
  const [lastSentDate, setLastSentDate] = useState<string>();

  const lastProformaDate = useCallback(() => {
    return ProformaInvoiceModel.getLastProformaSentDate(clientId);
  }, [clientId]);

  useEffect(() => {
    lastProformaDate()
      .then(setLastSentDate)
      .catch(() => {});
  }, [lastProformaDate, email]);

  return lastSentDate;
}; 